import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledPill,
  StyledIcon,
  StyledDetail,
  StyledCloseIconWrapper
} from './Styles';
import Detail from '../Detail';

const propTypes = {
  testId: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['information', 'warning', 'error', 'filter'])
    .isRequired,
  message: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func
};

const defaultProps = {
  testId: undefined,
  className: undefined,
  onClick: () => undefined,
  onKeyPress: () => undefined
};

function getIcon(variant) {
  if (variant === 'filter') {
    return 'TR5-Close_X';
  }
  return `TR5-${variant.charAt(0).toUpperCase() + variant.slice(1)}_msg`;
}

const Pill = ({
  testId,
  className,
  variant,
  message,
  id,
  onClick,
  onKeyPress
}) => (
  <StyledPill
    data-testid={testId}
    className={className}
    id={id}
    variant={variant}
  >
    {variant === 'filter' ? (
      <>
        <StyledDetail testId={`${testId}-pill`}>{message}</StyledDetail>
        <StyledCloseIconWrapper
          role="button"
          tabIndex={0}
          onClick={onClick}
          onKeyPress={onKeyPress}
        >
          <StyledIcon icon={getIcon(variant)} variant={variant} />{' '}
        </StyledCloseIconWrapper>
      </>
    ) : (
      <>
        <StyledIcon icon={getIcon(variant)} variant={variant} />{' '}
        <Detail.Value>{message}</Detail.Value>
      </>
    )}
  </StyledPill>
);

Pill.propTypes = propTypes;
Pill.defaultProps = defaultProps;

export default Pill;
